export let persona1Animation = () => {
  let thisSection = $(".impactPersona1");
  let thisPersona = $(thisSection).find('svg');
  let p1Back = $(".persona1Background");
  let p1BackPath = $(p1Back).find('path');

  let p1Img = $(".persona1Image")

  let p1Tri = $(".persona1Triangles")
  let p1TriPoly = $(p1TriPoly).find('polygon');

  let p1Waves = $(".persona1Waves")
  let p1WavePath = (p1Waves).find('path');

  let p1Wedge = $(".persona1Wedge")
  let p1WedgePath = $(p1Wedge).find('path');

  let p1Chart = $(".persona1Chart")
  let p1ChartPath = p1Chart.find('path')
  let p1ChartLine = p1Chart.find('line')

  let p1ChartText = $(".persona1ChartText")
  let p1ChartTextPath = $(p1ChartText).find('path');
  
  let p1Pieces = [p1Back, p1Tri, p1Waves, p1Chart, p1ChartText];

  let text = $(".impactPersona1Text").children();
  
  gsap.set(thisSection, {perspective:1000});
  gsap.set([p1Pieces,p1Wedge], {opacity:0});
  gsap.set(text, {opacity:0, y:-3});
  gsap.set(thisPersona, {rotationY:10, opacity:0.3, transformOrigin:"40% 50%"});

  let tl = gsap.timeline({
    defaults:{
      duration:0.5,
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top center",
      ease:'circ.out',
      // toggleActions:'play reverse play reverse',
    }
  });
  tl.to(thisPersona, {duration:1, rotationY:0, opacity:1}, "pOut1");
  tl.to(text, {opacity:1, y:0, stagger:0.1}, "pOut1+=0.2");
  tl.to(p1Pieces, {opacity:1, stagger:{
      amount:0.5,
      from:'random',
    }
  }, "pOut1+=0.1");
  tl.to(p1Wedge, {opacity:.25}, "pOut1+=0.1");
  

}

export let persona2Animation = () => {
  let thisSection = $(".impactPersona2");
  let thisPersona = $(thisSection).find('svg');
  let p2Back= $(".persona2Background")
  let p2BackRect = $(p2Back).find('rect');
  let p2BackPoly = $(p2Back).find('polygon');


  let p2Chart= $(".persona2Chart")
  let p2ChartPath = $(p2Chart).find('path');

  let p2ChartText = $(".persona2ChartText")
  let p2ChartTextPath = $(p2ChartText).find('path');

  let p2Img = $(".persona2Image")

  let p2Ruler = $(".persona2Ruler")
  let p2RulerPath = $(p2Ruler).find('path');
  let p2RulerLine = $(p2Ruler).find('line');

  let p2Pluses = $(".persona2Pluses")
  let p2PlusesPath = $(p2Pluses).find('path');

  let p2Pieces = [p2Back, p2Chart, p2ChartText, p2Ruler, p2Pluses];

  let text = $(".impactPersona2Text").children();
  
  gsap.set(thisSection, {perspective:1000});
  gsap.set(p2Pieces, {opacity:0});
  gsap.set(text, {opacity:0, y:-3});
  gsap.set(thisPersona, {rotationY:-10, opacity:0.3, transformOrigin:"100% 50%"});

  let tl = gsap.timeline({
    defaults:{
      duration:0.5,
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top center",
      ease:'circ.out',
      // toggleActions:'play reverse play reverse',
    }
  });
  tl.to(thisPersona, {duration:1, rotationY:0, opacity:1}, "pOut1");
  tl.to(text, {opacity:1, y:0, stagger:0.1}, "pOut1+=0.2");
  tl.to(p2Pieces, {opacity:1, stagger:{
      amount:0.3,
      from:'random',
    }
  }, "pOut1+=0.1");

}

export let persona3Animation = () => {
  let thisSection = $(".impactPersona3");
  let thisPersona = $(thisSection).find('svg');
  let p3Back= $(".persona3Background")
  let p3BackPath = $(p3Back).find('path');
  let p3BackRect = $(p3Back).find('rect');

  let p3Img = $(".persona3Image")

  let p3Numbers = $(".persona3Numbers");
  let p3NumbersPath = $(p3Numbers).find('path');

  let p3Dial = $(".persona3Dial")
  let p3DialPath = $(p3Dial).find('path');

  let p3Dots = $(".persona3Dots")
  let p3DotsCircle = $(p3Dots).find('circle');

  let p3Pieces = [p3Back, p3Numbers, p3Dial, p3Dots];

  let text = $(".impactPersona3Text").children();
  
  gsap.set(thisSection, {perspective:1000});
  gsap.set(p3Pieces, {opacity:0});
  gsap.set(text, {opacity:0, y:-3});
  gsap.set(thisPersona, {rotationY:10, opacity:0.3, transformOrigin:"50% 50%"});

  let tl = gsap.timeline({
    defaults:{
      duration:0.5,
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top center",
      ease:'circ.out',
      // toggleActions:'play reverse play reverse',
    }
  });
  tl.to(thisPersona, {duration:1, rotationY:0, opacity:1}, "pOut1");
  tl.to(text, {opacity:1, y:0, stagger:0.1}, "pOut1+=0.2");
  tl.to(p3Pieces, {opacity:1, stagger:{
      amount:0.3,
      from:'random',
    }
  }, "pOut1+=0.1");
}